/* eslint-disable camelcase */
import { useMemo } from "react";
import { arrayOf, func, shape, string } from "prop-types";
import Dropdown from "@shared/v2/Dropdown";
import { useGeneralRolesById, useTeamRolesById, useUserById } from "../../../reducers/autoPlanEdit";

const AssignToDropdown = ({options, setState, label, state, containerClassName}) => {
  const teamRolesById = useTeamRolesById()
  const userById = useUserById()
  const generalRolesById = useGeneralRolesById()

  const {
    assigned_to_type,
    assigned_to_id,
    assigned_to_role
  } = state;

  // Parents build `state` as a fresh object literal in their JSX, so deriving the value here (rather
  // than syncing it into local state from an effect keyed on `state`) avoids a second render pass on
  // every keystroke. Depend on the individual fields so the memo can actually hit.
  const value = useMemo(() => {
    const TYPE_TO_USE_ID = {
      'Role': teamRolesById,
      'User': userById
    }

    const lookupTable = TYPE_TO_USE_ID[assigned_to_type] || generalRolesById;
    const lookupValue = assigned_to_role || assigned_to_id;

    return {label: lookupTable[lookupValue], value: lookupValue}
  }, [assigned_to_type, assigned_to_id, assigned_to_role, teamRolesById, userById, generalRolesById])

  return (
    <Dropdown
      menuShouldComeToFront
      containerClassName={`tw-w-[264px] ${containerClassName}`}
      label={label}
      options={options}
      value={value}
      onChange={setState}
      isRequired/>
  )
};

export default AssignToDropdown;

AssignToDropdown.propTypes = {
  options: arrayOf(shape({})).isRequired,
  label: string.isRequired,
  setState: func.isRequired,
  state: shape({}),
  containerClassName: string
}

AssignToDropdown.defaultProps = {
  state: {},
  containerClassName: ''
}
